module.exports = __webpack_public_path__ + "static/fallback-ce8e7e8031ad3f2288f72b5d71f39edd.jpg";